<!--
 * @Author: kxl 939624959@qq.com
 * @Date: 2026-02-24 09:29:45
 * @LastEditors: kxl 939624959@qq.com
 * @LastEditTime: 2026-03-25 09:13:49
 * @Description: 请输入文件描述
-->
<template>
  <router-view />
</template>

<script setup lang="ts">
  import { onMounted } from 'vue'

  import 'animate.css'
  import 'aos/dist/aos.css'
  import AOS from 'aos'

  onMounted(() => {
    AOS.init({
      duration: 1000,
      easing: `ease-out-cubic`,
      once: false,
      mirror: true,
      offset: 50,
    })
  })
</script>
